module.exports = __webpack_public_path__ + "static/media/mymfbcover_pt_PT.1a285a71.png";